import { combineReducers } from 'redux';

import app from './appReducer';
import location from './locationReducer';
import texts from './textsReducer';
import filters from './filtersReducer';
import flightOffers from './flightOfferReducer';

const rootReducer = combineReducers({
  app,
  location,
  texts,
  filters,
  flightOffers,
  featureToggles: (state) => state || {},
  settings: (state) => state || {},
});

export default rootReducer;
